// extracted by mini-css-extract-plugin
export var headline = "headline-module--headline--282bb";
export var headlineSection = "headline-module--headline-section--75d8b";